import permission from "./permission";
import permisaction from "./permisaction";
import removeAriaHidden from "./removeAriaHidden";
var install = function install(Vue) {
  Vue.directive('permission', permission);
  Vue.directive('permisaction', permisaction);
  Vue.directive('removeAriaHidden', removeAriaHidden); // 新添加
};

if (window.Vue) {
  window['permission'] = permission;
  window['permisaction'] = permisaction;
  window['removeAriaHidden'] = removeAriaHidden; // 新添加
  // eslint-disable-next-line no-undef
  Vue.use(install);
}
permission.install = install;
export default permission;